import { DnsApiClient } from '@fourthwall/services/dist/DnsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateEntriProviderDetailsMutation = createMutationHook(
  DnsApiClient.updateEntriProviderDetails,
  {
    mutationKey: ['updateEntriProviderDetails'],
  },
)
